import React from "react";  

import {  
    ContentBody,
    ContentAnimation
} from "./styled";

import { 
    Animation
} from "ui/styled";

export default function NotFound(){ 
 
    return ( 
        
            <ContentBody>
                <ContentAnimation>
                    <Animation animationData={require('assets/lotties/404.json')}  />
                </ContentAnimation>
            </ContentBody>  
        
    );
}